import { StateCreator } from 'zustand';
import { AuthSlice } from './auth.types';

export const createAuthSlice: StateCreator<
  AuthSlice,
  [],
  [],
  AuthSlice
> = () => ({
  token: null,
});
